/** 端末別レイアウトの判定（仕様書 §12.1）。 */

import { useSyncExternalStore } from 'react';

export type Breakpoint = 'phone' | 'tablet' | 'desktop';

const TABLET_MIN = 768;
const DESKTOP_MIN = 1280;

function current(): Breakpoint {
  const w = window.innerWidth;
  if (w >= DESKTOP_MIN) return 'desktop';
  if (w >= TABLET_MIN) return 'tablet';
  return 'phone';
}

function subscribe(cb: () => void): () => void {
  const mqs = [
    window.matchMedia(`(min-width: ${TABLET_MIN}px)`),
    window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`),
  ];
  mqs.forEach((m) => m.addEventListener('change', cb));
  return () => mqs.forEach((m) => m.removeEventListener('change', cb));
}

export function useBreakpoint(): Breakpoint {
  return useSyncExternalStore(subscribe, current, () => 'desktop' as Breakpoint);
}
